import React from 'react';
import { Button } from './ui/Button';
import { openCalendlyPopup } from '../utils/calendly';
export function Header() {
  return <nav className="absolute top-0 left-0 w-full z-50 py-6 px-4 sm:px-6 lg:px-8" data-id="element-116">
      <div className="max-w-7xl mx-auto flex justify-between items-center" data-id="element-117">
        <a href="https://crm-kraft.de/" target="_blank" rel="noopener noreferrer" className="text-2xl font-bold text-white tracking-tight hover:opacity-90 transition-opacity" data-id="element-118">
          Justus<span className="text-[#FF5722]" data-id="element-119">Kraft</span>
        </a>
        <Button variant="primary" size="sm" onClick={openCalendlyPopup} data-id="element-120">
          Kostenlose Demo
        </Button>
      </div>
    </nav>;
}